import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.scss']
})
export class TenantComponent implements OnInit {
  availableTenants: string[];
  selectedTenant: string;
  tenantToSelect : string;

  constructor(private router: Router, private modalService: NgbModal) {
  }

  ngOnInit() {
    let tenants = JSON.parse(localStorage.getItem("okta-tenants"));
    if(tenants && tenants.availableTenants.length > 1){
      this.selectedTenant = tenants.selectedTenant;
      this.tenantToSelect = tenants.selectedTenant;
      this.availableTenants = tenants.availableTenants;
    }
  }

  /* select a new tenant before confirming */
  selectTenant(content){
    this.selectedTenant = this.tenantToSelect;

    // reset operation details as soon as modal is closed
    const domModal = this.modalService.open(content, { size: 'lg' }).result
      .then((result) => {
      }, (reason) => {
      });
  }

  /* triggers switch into a new tenant */
  switch(){
    let tenants = JSON.parse(localStorage.getItem("okta-tenants"));
    tenants.selectedTenant = this.selectedTenant;
    localStorage.setItem("okta-tenants", JSON.stringify(tenants));

    // get the keys in session storage
    let storageKeys = Object.keys(sessionStorage);
    // exclude "okta" related keys (also used for tenant selection)
    storageKeys = storageKeys.filter(k => k.indexOf('okta') !== 0);
    // delete all other keys
    storageKeys.forEach(k => sessionStorage.removeItem(k));

    this.router.navigateByUrl('/dashboard').then(() => {
      window.location.reload();
    });
  }

}
